<template>
  <div id="app">
    <div id="wrapper">
      <notifications group="appNotif" />
      <router-view name="login" :key="`${$route.fullPath}-login`"></router-view>
      <router-view name="landing" :key="`${$route.fullPath}-landing`"></router-view>
      <router-view name="navbar" :key="`${$route.fullPath}-navbar`"></router-view>
      <router-view name="content" :key="`${$route.fullPath}-content`"></router-view>
      <router-view class="col-12" name="report" :key="`${$route.fullPath}-report`"></router-view>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    setTimeout(() => {
    //   let libScript = document.createElement('script')
    // libScript.src = './assets/vendor/bundles/libscripts.bundle.js'
    // libScript.async = true
    // document.head.appendChild(libScript)

    // let datatableScript = document.createElement('script')
    // datatableScript.src = '/assets/bundles/datatablescripts.bundle.js'
    // datatableScript.async = true
    // document.head.appendChild(datatableScript)

    // let sweetalertScript = document.createElement('script')
    // sweetalertScript.src = '/assets/vendor/sweetalert/sweetalert.min.js'
    // sweetalertScript.async = true
    // document.head.appendChild(sweetalertScript)

    // let toastScript = document.createElement('script')
    // toastScript.src = '/assets/vendor/toastr/toastr.js'
    // toastScript.async = true
    // document.head.appendChild(toastScript)
    
    

    let knobScript = document.createElement('script')
    knobScript.src = '/assets/bundles/knob.bundle.js'
    knobScript.async = true
    document.body.appendChild(knobScript)

    let mainscript = document.createElement('script')
    mainscript.src = '/assets/bundles/mainscripts.bundle.js'
    mainscript.async = true
    document.body.appendChild(mainscript)

    let indexScript = document.createElement('script')
    indexScript.src = '/assets/js/index.js'
    indexScript.async = true
    document.body.appendChild(indexScript)

    let chartistScript = document.createElement('script')
    chartistScript.src = '/assets/bundles/chartist.bundle.js'
    chartistScript.async = true
    document.body.appendChild(chartistScript)

    // let jqueryDatatableScript = document.createElement('script')
    // jqueryDatatableScript.src = '/assets/js/pages/tables/jquery-datatable.js'
    // jqueryDatatableScript.async = true
    // document.head.appendChild(jqueryDatatableScript)

    // let dialogsScript = document.createElement('script')
    // dialogsScript.src = '/assets/js/pages/ui/dialogs.js'
    // dialogsScript.async = true
    // document.head.appendChild(dialogsScript)

    
    }, 1000)

    setTimeout(() => {
      

    let customScript = document.createElement('script')
    customScript.src = './assets/js/custom.js'
    customScript.async = true
    document.body.appendChild(customScript)

    

    
    }, 1500)
  }
}
</script>